export const ApiSlides = [
  {
    src: 'https://image.freepik.com/free-photo/happy-woman-with-shopping-bags_1150-20495.jpg',
    content: {
      h2: 'Amazing Deals this Summer',
      p: 'Upto 40% 0ff',
    },
    background: ' bg-[#C7E601]',
  },
  {
    src: 'https://st3.depositphotos.com/7713882/17906/i/600/depositphotos_179068502-stok-photo-happy-woman-showing-good-big.jpg',
    active: true,
    content: {
      h2: 'Avail Awesome Deals this week!',
      p: 'Upto 40% 0ff',
    },
    background: ' bg-[#ffd028]',
  },
];
